import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=505ae8b6&scoped=true&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=505ae8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ae8b6",
  null
  
)

export default component.exports